var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg6SenseIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0C070B;}\n\t.st1{fill:#00B3B0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.38488 0 0 .38488 10.868 7.1151e-8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m13.617 147.3 19.5-22.6c-4-6.6-5.2-15-2.1-22.8 4.1-10.6 14.4-16.8 25.7-16.1 2.9 0.2 5.7 0.9 8.3 2l19.6-22.7c-5.7-3.6-12.1-6.2-18.6-7.5 7-8.5 32.2-37.6 32.2-37.6l-22.3-20s-33.6 39.9-44.9 53.8c-6.7 8.3-13.5 16.6-20.2 24.9-8.6 10.6-12.1 26.1-10.4 39.7 1.5 11.1 6.3 21 13.2 28.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m105.12 88.8c-2.3-5.6-5.8-10.8-10.1-15.2l-19.4 22.5c3.9 5.2 5.9 11.9 4.9 18.7-1.9 13.5-15.3 24.6-29.2 22-3.1-0.4-5.9-1.4-8.5-2.8l-19.2 22.2c12.5 8.7 28.4 12.4 44.2 8.6 32.9-8 51.2-45 37.3-76"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6SenseIcon);
export default __webpack_public_path__ + "assets/media/6senseIcon.66559673.svg";
export { ForwardRef as ReactComponent };